import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Configurations } from '../../Utils/Configurations';
import moment from 'moment';
import 'react-table/react-table.css';
import {
    Modal, ModalBody, ModalHeader, ModalFooter, Button,
} from 'reactstrap';
import './Quick-Answer.scss';
import 'rc-pagination/assets/index.css';
import { withRouter } from 'react-router-dom';

const AnswerList = ({history}) => {

    const [lista, setLista] = useState()
    const [loading, setLoading] = useState(true)
    const [modalExcluir, setModalExcluir] = useState(false)
    const [idFrase, setIdFrase] = useState()

    const [titulo, setTitulo] = useState()
    const [loadingExcluir, setLoadingExcluir] = useState(false)




    const chamadaLista = () => {
        const config = new Configurations();
        axios.get(config.apiBasePath + `/resposta-rapida/lista`)
            .then(response => {
                setLista(response.data.data)

            })
            .catch(error => {
                console.log("ERROR: ", error)
            })
            .finally(() => {
                setLoading(false)
            });
    }



    const excluirResposta = () => {
        setLoadingExcluir(true);
        const config = new Configurations();
        axios.delete(config.apiBasePath + `/resposta-rapida/${idFrase}`)
            .then(() => {
                setLoadingExcluir(false)
            })
            .catch(error => {
                console.log("ERROR: ", error)
            })
            .finally(() =>
                window.location.reload()
            )
    }


    useEffect(() => {
        chamadaLista()
    }, [])

    const toggleModalExcluir = () => {
        setModalExcluir(!modalExcluir)
    }


    const selecionaResposta = (_idResposta) => {
        history.push(`detalhes/${_idResposta}`)
    }

    return (

        <div className="row lista-frases">
            <div className="col-12">
                <div className="row align-items-center">
                    <div className="col-12 text-center col-lg-8 text-lg-left">
                        <h2 className="d-none d-lg-block">Lista de respostas rápidas</h2>
                        <h3 className="d-lg-none">Lista de Respostas rápidas</h3>
                    </div>
                    <div className="col-12 text-center col-lg-4 text-right">
                        <button className="btn btn-outline-info" onClick={() => history.push('nova-resposta')}>Cadastrar nova resposta</button>
                    </div>

                    <div className={`col-12 text-center text-lg-left`}>
                        <p className="py-2 m-0">Clique na frase para obter mais detalhes e/ou fazer alterações.</p>
                    </div>
                    <div className="col-12 text-center">
                        <ul className="lista-frases-mob px-0">
                            {loading ?
                                <div className="spinner-border text-primary" role="status" />
                                :
                                lista.map((item, index) => {
                                    return <li className="py-2 list" key={index}>
                                        <div className="card rounded border border-secondary p-2 py-4 d-lg-block d-none">
                                            <div className="row">
                                                <div className="col-12">
                                                    <div className="row align-items-center">
                                                        <div className="col-12 pointer pb-4"
                                                            onClick={() => selecionaResposta(item.id)}
                                                        >
                                                            <p className="mb-2"><strong>{item.titulo}</strong></p>
                                                            <p className="m-0 font-frase-desktop" dangerouslySetInnerHTML={{__html: item.descricao}}/>
                                                        </div>
                                                        <div className="col-3 text-center">
                                                            <strong className="m-0">Data Criação</strong>
                                                            <p className="m-0 font-frase-desktop">{moment(item.dtCriacao).format("DD/MM/YY")}</p>
                                                        </div>
                                                        <div className="col-3 text-center">
                                                            <strong className="m-0">Data Alteração</strong>
                                                            <p className="m-0 font-frase-desktop">{moment(item.dtModificacao).format("DD/MM/YY")}</p>
                                                        </div>
                                                        <div className="col-3 text-center">
                                                            <strong className="m-0">Usuário</strong>
                                                            <p className="m-0 font-frase-desktop">{item.usuarioAcao[(item.usuarioAcao.length - 1)].nome}</p>
                                                        </div>
                                                        <div className="col-3 text-center d-flex justify-content-around">
                                                            <button
                                                                className="btn btn-sm btn-outline-info pointer"
                                                                onClick={() => selecionaResposta(item.id)}
                                                            >
                                                                Editar
                                                            </button>

                                                            <i className="text-danger far fa-trash-alt px-2 pt-1 pointer" onClick={() => setModalExcluir(true) + setIdFrase(item.id) + setTitulo(item.titulo)}></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                })
                            }

                        </ul>
                    </div>
                </div>
            </div>

            <Modal isOpen={modalExcluir} toggle={toggleModalExcluir}>
                <ModalHeader toggle={toggleModalExcluir}>Excluir Frase</ModalHeader>
                <ModalBody>
                    <p className="m-0">Tem certeza que deseja excluir a resposta <strong>{titulo}</strong>?</p>
                    <p className="m-0">Essa operação não poderá ser desfeita.</p>
                </ModalBody>
                <ModalFooter>
                    {loadingExcluir ? <div className="spinner-border text-danger" role="status" /> : <Button color='danger' onClick={() => excluirResposta()}>excluir</Button>}
                    {' '}<Button color="secondary" onClick={toggleModalExcluir}>voltar</Button>
                </ModalFooter>
            </Modal>

        </div>
    )

}

export default withRouter(AnswerList);
